import svgUrl from "ni:svgr;Lr7PPRM7Y2opSfbyFsEIRcG2QF5DeDso_wBFq94iz34";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const UnionLIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}><path fill="var(--tbl--colors--icons--transformation--primary)" fillRule="evenodd" d="M15.675 13.12a.5.5 0 0 1 .65 0l3.5 3a.5.5 0 1 1-.65.76L17 15.016V20h8a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-3a3 3 0 0 1 3-3h8v-4.984l-2.175 1.864a.5.5 0 1 1-.65-.76l3.5-3Z" clipRule="evenodd" /><rect width={24} height={9} x={4} y={3} fill="var(--tbl--colors--icons--transformation--tertiary)" rx={3} /></svg>;
const Memo = memo(UnionLIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "UnionLIcon";
}